import React, { useEffect, useState } from "react";
import "./CommonBanner.css";
import { Link } from "react-router-dom";

import banner1 from "../assets/herobanner.png";
import banner2 from "../assets/herobanner2.png";

import pump1 from "../assets/phota.png";
import pump2 from "../assets/phota2.png";

const slides = [
  {
    bg: banner1,
    title: "ALL TYPE OF",
    highlight: "CENTRIFUGAL PUMPS",
    // desc: "Manufacturer of Centrifugal Pumps, Pump Spares and Spares for Sugar and Engineering Industry.",
    img: pump1,
  },
  {
    bg: banner2,
    title: "GLANDLESS TRANSFORMER",
    highlight: "OIL PUMPS",
    // desc: "High-performance cooling solutions for industrial applications.",
    img: pump2,
  },
];

const CommonBanner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${slides[index].bg})` }}
    >
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="hero-left">
          <img src={slides[index].img} className="pump" alt="pump" />
        </div>

        <div className="hero-right">
          <h1>
            {slides[index].title}
            <br />
            <span>{slides[index].highlight}</span>
          </h1>

          <p>{slides[index].desc}</p>

          <Link to="/contact">
            <button className="cta">SEND ENQUIRY</button>
          </Link>

          <div className="dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={i === index ? "active" : ""}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonBanner;
